/* globals tv */

import { isVideoSupported } from '../utils/ASVPUtils';
import ASDebugger from '../utils/ASDebugger';
import isMobile from 'ismobilejs';
import VideoJS from 'video.js';
require('../lib/freewheel-ad-manager');

import Controls from './controls';
import Analytics from './analytics';
import Ads from './ads';

import VIDEO_JS_DEFAULTS from '../config/video-js-defaults';
import assign from 'lodash/assign';

import HlsJsStreamrootHandler from './hlsjs-streamroot-handler';

import { fetchVideo } from './service';
import {
    RECONNECTING_SLATE,
    NOT_FOUND_SLATE,
    FORBIDDEN_SLATE,
    PROBLEM_SLATE,
    HLS_MIME_TYPE,
    LOCALSTORAGE_MUTED,
    LOCALSTORAGE_CAPTIONS
} from '../config/player';

import 'core-js/fn/promise';
import 'core-js/fn/string/includes';
import attempt from 'lodash/attempt';

var AdultSwimVideoPlayer = function (options) {
    this.elementID = options.element;
    this.videoID = options.videoID;
    this.videoOptions = options.options;
    this.loadErrorCount = 0;

    this.debug = ASDebugger(this.videoOptions.debug || false);
    Analytics.setDebug(this.videoOptions.debug);

    this.originalVideoTagParent = $('#' + this.elementID).parent();
    this.originalVideoTag = $('#' + this.elementID).clone();

    this.videoElement = document.getElementById(this.elementID);

    this.videoElement.classList.add('adult-swim-video-player');
    this.videoElement.classList.add(isMobile.any ? 'mobile' : 'not-mobile');
    this.videoElement.classList.add(isMobile.android.device ? 'mobile--android' : 'not-mobile--android');
    this.videoElement.classList.add(isMobile.apple.device ? 'mobile--apple' : 'not-mobile--apple');
    this.videoElement.classList.add(isMobile.phone ? 'mobile--phone' : 'not-mobile--phone');
    this.videoElement.classList.add(isMobile.tablet ? 'mobile--tablet' : 'not-mobile--tablet');

    // Show unsupported slate if broswer doesn't have MediaSource
    if (!isVideoSupported()) {
        this.videoElement.classList.add('your-browser-sux');
    }

    this.isMuted = attempt(function() {
        return !!JSON.parse(window.localStorage.getItem(LOCALSTORAGE_MUTED));
    });
    this.captionsOn = attempt(function() {
        return !!JSON.parse(window.localStorage.getItem(LOCALSTORAGE_CAPTIONS));
    });

    this.initVideoJSPlayer();
    HlsJsStreamrootHandler(this.videoOptions.hlsJS);

    this.ads = (this.videoOptions.ads) ? new Ads(this.videoJS, this.videoOptions.ads) : null;
    this.controls = new Controls(this.videoJS, this.videoData, this.videoOptions);

    return this;
};


AdultSwimVideoPlayer.prototype.registerEvent = function (eventName, callback) {
    this.videoJS.on(eventName, callback);

    return this.deregisterEvent.bind(this, eventName, callback);
};

AdultSwimVideoPlayer.prototype.deregisterEvent = function (eventName, func) {
    this.videoJS.off(eventName, func);
};

AdultSwimVideoPlayer.prototype.setVideo = function(videoID = null, options = {}) {
    if (!this.ready) {
        this.debug.error('Player not ready yet.');
        return false;
    }
    if (!videoID && !this.videoID) {
        this.debug.error('No video ID set.');
        return false;
    }
    if (!videoID) videoID = this.videoID;

    fetchVideo(videoID)
        .then((data) => {

            this.videoData = data;
            this.setAsset(data);

            // if vtt file is in the service return, and hls provider is not being used, attach the vtt
            if (!this.videoJS.tech_.hlsProvider) this.detachWebVTT();
            if (this.videoData.vtt && !this.videoJS.tech_.hlsProvider) this.attachWebVTT();

            if (this.ads) this.ads.setContext(data, this.adEvents);
            this.controls.setVideoData(data);

            this.videoStarted = false;
            this.timeUpdateStarted = false;
            this.videoFiftyCalled = false;

            if (options.success) options.success();
        })
        .catch((err) => {
            if (options.error) options.error();
            else this.debug.error(err); // needs RESPONSE TEXT FROM GALACTUS
        });
};


AdultSwimVideoPlayer.prototype.getPlayer = function() {
    return this.videoJS;
};

AdultSwimVideoPlayer.prototype.destroy = function(destroyVideoTag) {
    window.clearInterval(this.recheckLiveStreamInterval);

    // destroy hls.js and video.js
    if (this.videoJS.tech_.hlsProvider) this.videoJS.tech_.hlsProvider.dispose();
    this.videoJS.dispose();

    if (!destroyVideoTag) {
        this.originalVideoTagParent.append(this.originalVideoTag);
    }
};


AdultSwimVideoPlayer.prototype.setAsset = function (data) {
    this.cleanUpAds();

    var assetURL = (data) ? data.assetURL : null;
    var poster = (isVideoSupported() && data) ? data.poster : '';

    if (assetURL) {
        this.videoJS.poster(poster);
        this.videoJS.src({ 'type': HLS_MIME_TYPE, 'src': assetURL });
    }
    else {
        this.debug.error('No video asset returned from video service :', data);
    }
};


// removes any ad divs left over from broken FW code
AdultSwimVideoPlayer.prototype.cleanUpAds = function() {
    if (!this.ads) return;

    if (this.adPlaying) this.ads.skipAd();

    this.adPlaying = false;
    this.videoJS.removeClass('ad-playing');
    this.videoJS.removeClass('ad-loading');

    if (this.videoJS.el().children[0].tagName === 'DIV') {
        this.videoJS.el().removeChild(this.videoJS.el().children[0]);
    }
};

AdultSwimVideoPlayer.prototype.attachWebVTT = function (e) {
    var track = {};
    track.kind = 'captions';
    track.label = 'English';
    track.default = false;
    track.mode = 'disabled';
    track.srclang = 'en';
    track.src = this.videoData.vtt;
    this.videoJS.tech_.el_.setAttribute('crossorigin', 'anonymous');

    // console.log('!!! using remote track', track);
    this.videoJS.addRemoteTextTrack(track);
};

AdultSwimVideoPlayer.prototype.detachWebVTT = function () {
    var tracks = this.videoJS.textTracks();
    for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];

        this.videoJS.removeRemoteTextTrack(track);
        // this.videoJS.tech_.textTracks().removeTrack_(track);  // removes it permanently, can't be added back by hls.js
    }
};

AdultSwimVideoPlayer.prototype.detectCues = function () {
    var tracks = this.videoJS.textTracks();
    for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];

        if (track.cues && track.cues.length) {
            // console.log('!!! show CC button');
        } else {
            track.mode = 'disabled';
            // console.log('!!! hide CC button');
        }
    }
};



// this is necessary because of the interaction between hls.js and videojs isn't removing old tracks when switching sources
AdultSwimVideoPlayer.prototype.hideTextTracks = function () {
    var tracks = this.videoJS.textTracks();
    for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];

        track.mode = 'disabled';
    }
};

// this is necessary because of the interaction between hls.js and videojs isn't removing old tracks when switching sources
AdultSwimVideoPlayer.prototype.hideCaptions = function () {
    var tracks = this.videoJS.textTracks();
    for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];

        if (track.kind === 'captions') track.mode = 'disabled';
    }
};

// this is necessary because of the interaction between hls.js and videojs isn't removing old tracks when switching sources
AdultSwimVideoPlayer.prototype.hideSubtitles = function () {
    var tracks = this.videoJS.textTracks();
    for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];

        if (track.kind === 'subtitles') track.mode = 'disabled';
    }
};


AdultSwimVideoPlayer.prototype.saveCaptionState = function () {
    var tracks = this.videoJS.textTracks();
    for (var i = 0; i < tracks.length; i++) {
        var track = tracks[i];
        if (track.kind !== 'captions') continue;

        if (track.mode === 'showing') {
            window.localStorage.setItem(LOCALSTORAGE_CAPTIONS, 'true');
        } else {
            window.localStorage.setItem(LOCALSTORAGE_CAPTIONS, 'false');
        }
    }

    this.debug.log('saveCaptionState', !!JSON.parse(window.localStorage.getItem(LOCALSTORAGE_CAPTIONS)));
};


// ultra hacky method for fixing caption selector when using addTrack_ on embedded captions
AdultSwimVideoPlayer.prototype.fixVideoJSCaptionSelector = function (textTrack) {
    if (this.videoJS.tech_.hlsProvider) {
        var captionSelections = this.videoJS.controlBar.getChild('CaptionsButton').menu.children_;

        // only run if there's exactly 1 caption available
        if (captionSelections.length === 3) {
            // if captions should be disabled, take off selected class on all captions
            for (var i = 0; i < captionSelections.length; i++) {
                var captionSelection = captionSelections[i].el_;

                captionSelection.classList.remove('vjs-selected');
            }

            // put the selected class back on
            if (textTrack.mode === 'disabled') captionSelections[1].el_.classList.add('vjs-selected');
            else captionSelections[2].el_.classList.add('vjs-selected');
        }
    }
};




AdultSwimVideoPlayer.prototype.initVideoJSPlayer = function () {
    var asPlayer = this;
    var mergedOptions = assign({}, VIDEO_JS_DEFAULTS, this.videoOptions);

    // initialize the hls.js player through the VideoJS library
    this.videoJS = new VideoJS(
        this.elementID,
        mergedOptions
    ).on('ready', function () {
        asPlayer.debug.log('ready');

        asPlayer.ready = true;

        // set initial mute state from local storage
        if (asPlayer.isMuted) {
            asPlayer.videoJS.muted(true);
        }

        // set ad events and make service call for video content
        asPlayer.setAdEvents();
        asPlayer.setVideo();


        // trigger special events from hls tech
        asPlayer.videoJS.tech_.off('hlsLoadError');
        asPlayer.videoJS.tech_.on('hlsLoadError', function (e, error) {
            asPlayer.videoJS.trigger('hlsLoadError', error);
        });

        asPlayer.videoJS.tech_.off('hlsLevelLoaded');
        asPlayer.videoJS.tech_.on('hlsLevelLoaded', function (e, data) {
            asPlayer.videoJS.trigger('hlsLevelLoaded', data);
        });

        asPlayer.videoJS.tech_.off('hlsMediaAttached');
        asPlayer.videoJS.tech_.on('hlsMediaAttached', function (e, data) {
            asPlayer.videoJS.trigger('hlsMediaAttached', data);
        });

        // listener for adding embedded captions.  this is necessary to add captions back to the videoJS captions method
        asPlayer.videoJS.tech_.el().textTracks.addEventListener('addtrack', (e) => {
            // console.log('!!! addtrack', e.target[0]);

            var textTrack = e.target[0];
            textTrack.default = false;
            textTrack.mode = 'disabled';

            // if there's not already a text track on the video, add the embedded one
            // if (!asPlayer.videoJS.textTracks().length) {
                // asPlayer.videoJS.addTextTrack(textTrack.kind, textTrack.label, textTrack.language);
                // console.log('!!! using embedded track', textTrack);
                asPlayer.videoJS.tech_.textTracks().addTrack_(textTrack);
            // }

            asPlayer.newTrack = true;

            // we never want subtitles, only captions
            // this is necessary because a lot of our VODs have a subtitle vtt file attached to them in the master playlist
            asPlayer.hideSubtitles();

        }, false);

        asPlayer.videoJS.tech_.el().textTracks.addEventListener('change', (e) => {
            // console.log('!!! changetrack', e.target[0]);

            // turn off track on newly added tracks (this only applies to native hls players)
            if (asPlayer.newTrack) {
                asPlayer.newTrack = false;
                if (!asPlayer.videoJS.tech_.hlsProvider) asPlayer.hideTextTracks();
            }

            asPlayer.fixVideoJSCaptionSelector(e.target[0]);

            // asPlayer.saveCaptionState();
        }, false);
    })


    .on('play', function () {
        asPlayer.debug.log('play');

        asPlayer.finished = false;


        // if has ads and prerolls, start the preroll
        if (asPlayer.ads && asPlayer.ads.prerolls && asPlayer.ads.prerolls.length) {
            asPlayer.adPlaying = true;
            if (asPlayer.videoJS.tech_.hlsProvider) asPlayer.videoJS.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
            asPlayer.ads.startPreroll();
        }

        // reset checking live stream
        if (asPlayer.recheckLiveStreamInterval) {
            window.clearInterval(asPlayer.recheckLiveStreamInterval);
            asPlayer.recheckLiveStreamInterval = null;
        }

        // reattach media if live, to set user back to as to live as possible
        if (asPlayer.paused && asPlayer.videoJS.duration() === Infinity && !asPlayer.adPlaying) {
            asPlayer.setAsset(asPlayer.videoData);
        }

        // pause fires after video has ended on it's own, don't fire the tracking for that case
        if (asPlayer.paused && !asPlayer.adPlaying) {
            Analytics.trackVideoPause(asPlayer.videoData, {
                paused : asPlayer.videoJS.paused()
            });
        }

        // remove share overlay
        asPlayer.controls.removeShareOverlay();

        asPlayer.paused = false;
    })


    .on('playing', function () {
        asPlayer.debug.log('playing');

        if (!asPlayer.videoStarted && !asPlayer.adPlaying) {
            Analytics.trackVideoStart(asPlayer.videoData, {
                autoplayed : asPlayer.videoJS.autoplay()
            });

            asPlayer.videoStarted = true;
        }
    })


    .on('pause', function () {
        asPlayer.debug.log('pause');

        // pause fires after video has ended on it's own, don't fire the tracking for that case
        if (!asPlayer.paused && !asPlayer.adPlaying) {
            Analytics.trackVideoPause(asPlayer.videoData, {
                paused : asPlayer.videoJS.paused()
            });
        }

        asPlayer.paused = true;
    })


    .on('waiting', function () {
        asPlayer.debug.log('waiting');

        if (!asPlayer.adPlaying) Analytics.trackVideoBuffering(asPlayer.videoData);
    })


    .on('loadeddata', function () {
        asPlayer.debug.log('loadeddata');

        // return to time if coming out of a midroll,
        // use slight timeout to take care of hls loading then seeking weirdness
        setTimeout(() => {
            if (!asPlayer.adPlaying && asPlayer.returnToTime && asPlayer.returnToTime > 0) {
                asPlayer.videoJS.currentTime(asPlayer.returnToTime);
                asPlayer.returnToTime = false;
            }

            if (asPlayer.ads && !asPlayer.adPlaying) asPlayer.controls.setMidrollPoints(asPlayer.ads.midrolls);
        }, 50);
    })


    .on('timeupdate', function () {
        // this.debug.log('timeupdate');

        if (!asPlayer.adPlaying) calculateProgress(asPlayer);

        if (asPlayer.ads &&
            asPlayer.ads.midrolls &&
            asPlayer.ads.midrolls.length &&
            !asPlayer.adPlaying) asPlayer.monitorMidrollStarts();
    })


    .on('ended', function () {
        asPlayer.debug.log('ended');

        if (!asPlayer.adPlaying) {
            Analytics.trackVideoComplete(asPlayer.videoData);

            if (asPlayer.ads && asPlayer.ads.postrolls.length) {
                // play postroll
                asPlayer.adPlaying = true;
                if (asPlayer.videoJS.tech_.hlsProvider) asPlayer.videoJS.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
                asPlayer.ads.startPostroll();
            } else {
                if (asPlayer.ads) asPlayer.ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);
                asPlayer.videoJS.trigger('finished', asPlayer.videoData);
            }
        }

        // if asPlayer video should a stream and it actually ended, try to reconnect altogether to get it back to live
        if (asPlayer.videoData && asPlayer.videoData.type === 'stream') {
            asPlayer.recheckLiveStreamInterval = window.setInterval(function () {
                asPlayer.videoJS.pause();
                asPlayer.setAsset(asPlayer.videoData);
            }, 15000);
        }
    })


    // custom finished event to account for ad postroll
    .on('finished', function () {
        asPlayer.debug.log('finished');

        asPlayer.finished = true;
    })


    .on('hlsLevelLoaded', function (e, data) {
        // shows reconnecting slate if what's supposed to be a live stream has an End OF Playlist tag in it's manifest
        if (asPlayer.videoData && asPlayer.videoData.type === 'stream' && data.details.type === 'VOD') {
            asPlayer.slate(RECONNECTING_SLATE);
        }
    })

    .on('error', (e) => {
        this.debug.log(e);
    })

    .on('hlsLoadError', (event, error) => {
        this.videoJS.pause();

        if (error && error.response && error.response.code === 403) {
            this.videoJS.poster(FORBIDDEN_SLATE);
        } else if (error && error.response && error.response.code === 404) {
            this.videoJS.poster(NOT_FOUND_SLATE);
        } else {
            this.videoJS.poster(PROBLEM_SLATE);
        }

        var recheckLiveStream = () => {
            this.setAsset(this.videoData);
        };

        this.recheckLiveStreamInterval = window.setInterval(recheckLiveStream, 60000);
    });
};



AdultSwimVideoPlayer.prototype.setAdEvents = function () {
    var asPlayer = this;
    this.adEvents = {};

    this.adEvents.onAdRequestComplete = (e) => {
        asPlayer.debug.log('ads : adRequestComplete', e);

        if (e.success) asPlayer.ads.setSlots();

        // if not supposed to autoplay, stop right here
        if (!asPlayer.videoJS.autoplay()) return;

        // if has preroll, play it
        if (asPlayer.ads.prerolls.length) {
            asPlayer.adPlaying = true;
            if (asPlayer.videoJS.tech_.hlsProvider) asPlayer.videoJS.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
            asPlayer.ads.startPreroll();
        } else {
            asPlayer.setAsset(asPlayer.videoData);
        }
    };

    this.adEvents.onAdSlotStarted = (e) => {
        if (e.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY) return false;

        asPlayer.debug.log('ads : adSlotStarted', e);

        asPlayer.controls.adCountdown(e.slot);

        if (asPlayer.videoStarted) asPlayer.ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PAUSED);

        asPlayer.adPlaying = true;

        asPlayer.videoJS.addClass('ad-loading');

        switch (asPlayer.ads.currentPlayingSlotType) {
            case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:
                Analytics.trackPreroll(asPlayer.videoData);
                break;
            case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:
            // case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:
                Analytics.trackMidrollStart(asPlayer.videoData);
                break;
            case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:
                Analytics.trackPostrollStart(asPlayer.videoData);
                break;
        }

        // trigger on player for external ad listeners
        asPlayer.videoJS.trigger('ad-start', { slot: e.slot, adType: e.slot.getTimePositionClass().toLowerCase() });
    };

    this.adEvents.onAdSlotEnded = (e) => {
        if (e.slot.getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY) return false;

        asPlayer.debug.log('ads : adSlotEnded', e);

        asPlayer.controls.adCountdown(false);

        var slotTimePositionClass = e.slot.getTimePositionClass();

        asPlayer.videoJS.removeClass('ad-playing');
        asPlayer.videoJS.removeClass('ad-loading');

        switch (slotTimePositionClass) {
            case tv.freewheel.SDK.TIME_POSITION_CLASS_PREROLL:
                asPlayer.ads.prerolls.splice(0, 1);

                // if there's another preroll to play
                if (asPlayer.ads.prerolls.length) {
                    asPlayer.ads.startPreroll();

                    return;
                } else {
                    asPlayer.setAsset(asPlayer.videoData);
                    asPlayer.ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);

                    if (!asPlayer.videoJS.autoplay()) asPlayer.videoJS.play();
                }

                break;
            case tv.freewheel.SDK.TIME_POSITION_CLASS_MIDROLL:
            // case tv.freewheel.SDK.TIME_POSITION_CLASS_OVERLAY:
                asPlayer.ads.midrolls.splice(0, 1);

                Analytics.trackMidrollComplete(asPlayer.videoData);
                asPlayer.setAsset(asPlayer.videoData);
                asPlayer.ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_PLAYING);

                break;
            case tv.freewheel.SDK.TIME_POSITION_CLASS_POSTROLL:
                asPlayer.ads.postrolls.splice(0, 1);

                // if there's another postroll to play
                if (asPlayer.ads.postrolls.length) {
                    if (asPlayer.videoJS.tech_.hlsProvider) asPlayer.videoJS.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
                    asPlayer.ads.startPostroll();

                    return;
                } else {
                    Analytics.trackPostrollComplete(asPlayer.videoData);
                    asPlayer.ads.setContextVideoState(tv.freewheel.SDK.VIDEO_STATE_COMPLETED);

                    asPlayer.videoJS.trigger('finished', asPlayer.videoData);
                }

                break;
        }

        asPlayer.ads.currentPlayingSlot = null;
        asPlayer.ads.currentPlayingSlotType = null;
        asPlayer.adPlaying = false;

        // trigger on player for external ad listeners
        asPlayer.videoJS.trigger('ad-complete', { slot: e.slot, adType: e.slot.getTimePositionClass().toLowerCase() });
    };

    this.adEvents.onAdImpressionStarted = (e) => {
        var adInstance = e.adInstance;

        if (adInstance.getSlot().getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY) return false;

        asPlayer.debug.log('ads : ad impression started : adInstance :', adInstance);

        asPlayer.videoJS.addClass('ad-playing');
        asPlayer.videoJS.removeClass('ad-loading');
    };

    this.adEvents.onAdImpressionEnded = (e) => {
        var adInstance = e.adInstance;

        if (adInstance.getSlot().getTimePositionClass() === tv.freewheel.SDK.TIME_POSITION_CLASS_DISPLAY) return false;

        asPlayer.videoJS.removeClass('ad-playing');

        asPlayer.debug.log('ads : ad impression ended : adInstance : ', adInstance);
    };

    this.adEvents.onAdError = (e) => {
        asPlayer.debug.error('ads : error : ', e);
    };

    this.adEvents.onAdClick = (e) => {
        asPlayer.debug.log('ads : ad click : ', e);
    };
};


AdultSwimVideoPlayer.prototype.monitorMidrollStarts = function () {
    for (var i = 0; i < this.ads.midrolls.length; i++) {
        var slot = this.ads.midrolls[i];
        var slotTimePosition = slot.getTimePosition();
        var videoCurrentTime = this.videoJS.currentTime();
        var midrollsToRemove = 0;

        if ((videoCurrentTime - slotTimePosition >= 0 && videoCurrentTime - slotTimePosition <= 1)) {
            // remove all previous midrolls
            for (var j = 0; j < this.ads.midrolls.length; j++) {
                if (slotTimePosition > this.ads.midrolls[j].getTimePosition()) {
                    midrollsToRemove++;
                }
            }
            this.ads.midrolls.splice(0, midrollsToRemove);

            this.returnToTime = videoCurrentTime;
            this.adPlaying = true;
            if (this.videoJS.tech_.hlsProvider) this.videoJS.tech_.hlsProvider.dispose();  // dispose of hls source handler to start ads faster
            this.ads.startMidroll(slot);

            return;
        }
    }
};




function calculateProgress (asPlayer) {
    var ct = parseInt(asPlayer.videoJS.currentTime());

    if (!asPlayer.timeUpdateStarted) {
        asPlayer.firstTime = ct;
        asPlayer.timeUpdateStarted = true;
    }

    // only eval once per second inc, since timeupdate pops ~4 times per second
    // only fire if duration is greater than 0
    if (asPlayer.lastTime !== ct && (ct - asPlayer.firstTime) > 0) {
        // if current time is divisible by 10 then an inc of 10s has passed
        if (ct % 60 === 0) {
            Analytics.trackVideoProgress(asPlayer.videoData, {
                duration : ct - asPlayer.firstTime
            });
        }
    }
    asPlayer.lastTime = ct;

    // if VOD and current time is greater than halfway point of the video
    if (ct > (asPlayer.videoJS.duration() / 2) &&
        asPlayer.videoData &&
        asPlayer.videoData.type !== 'stream' &&
        !asPlayer.videoFiftyCalled) {
        Analytics.trackVideoFifty(asPlayer.videoData, {
            duration : ct - asPlayer.firstTime
        });

        asPlayer.videoFiftyCalled = true;
    }
};

export default AdultSwimVideoPlayer;


// WEBPACK FOOTER //
// ./src/player/index.js